import { Component, OnInit, Input } from '@angular/core'
import { FormControl } from '@angular/forms'

import { IFlowReservation } from 'app/shared/steps/step.model';
import { Direction } from '../cabin-fares.interfaces';
import { EnvironmentService } from 'app/environment.service';

@Component({
    selector: 'sbw-cabin-fares-selector',
    templateUrl: './cabin-fares-selector.component.html',
    styleUrls: ['./cabin-fares-selector.component.css']
})
export class CabinFaresSelectorComponent implements OnInit {

    @Input() model: IInputCabinFaresSelector
    @Input() reservation: IFlowReservation
    @Input() form: FormControl
    public contentfulEditMode: boolean
    adults: number
    numberOfAvailableCabins: number[];

    constructor(private environmentService: EnvironmentService) { }

    ngOnInit() {
        this.environmentService.contentfulEditModeChanged$
            .subscribe(enabled => {
                this.contentfulEditMode = enabled
            })

        if (this.reservation) {
            this.adults = this.reservation.adults
        }
        this.generateNumberOfAvailableCabinsForDropDown()
    }

    generateNumberOfAvailableCabinsForDropDown() {
        this.numberOfAvailableCabins = Array.from({ length: + this.adults + 1 }, (_, k) => k)
        if (this.model.availableCapacity < this.adults + 1) this.numberOfAvailableCabins.length = this.model.availableCapacity + 1
    }

}

export interface IInputCabinFaresSelector {
    genericId: string
    cabinTypeCode: string
    direction: Direction
    description: string
    currency: string
    price: number
    outboundPrice?: number
    returnPrice?: number
    originalPrice?: number
    numberOfOccupiableBerths: number
    cabinDetailsFromContentful?: any
    numberOfSuggested: number
    availableCapacity: number
}
